module.exports = __webpack_public_path__ + "static/headtilt-3368824707f0bcd9091b040001b8eb5d.gif";